<template lang="pug">

  section.video
    div(style='padding:56.25% 0 0 0;position:relative;')
      iframe#vrudo.vrudo(:src="src", allowscriptaccess='always', allowfullscreen='true', webkitallowfullscreen='true', frameborder='0', scrolling='no', allow='autoplay; fullscreen', style='position:absolute;top:0;left:0;width:100%;height:100%;')

</template>

<script lang="js">
  export default  {
    name: 'Video',
    props: {
      src: {
        type: String,
        default: '//rudo.video/vod/bGaUbU/autostart/false'
      }
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .video {

  }
</style>
